<div mat-dialog-content class="form">
    <mat-form-field>
        <mat-label>{{ 'aumico_templates_subtotal_form_subtotal_name' | i18next }}</mat-label>
        <input matInput [formControl]="subtotalNameControl" required />
        <mat-error *ngIf="subtotalNameControl.hasError('required')">
            {{ 'aumico_templates_subtotal_form_enter_subtotal_name_error' | i18next }}
        </mat-error>
        <mat-error *ngIf="subtotalNameControl.hasError('subtotalNameExists')">
            {{ 'aumico_templates_subtotal_form_name_already_exists_error' | i18next }}
        </mat-error>
    </mat-form-field>
    <br />
    <div class="d-flex" [formGroup]="subtotalTranslatedFormGroup">
        <mat-form-field>
            <mat-label>{{ 'aumico_templates_description' | i18next }} </mat-label>
            <input matInput formControlName="description" />
            <mat-error *ngIf="subtotalTranslatedFormGroup.get('description').hasError('required')">
                {{ 'aumico_templates_subtotal_form_enter_subtotal_description_error' | i18next }}
            </mat-error>
        </mat-form-field>
        <aum-select
            placeholder="{{ 'aumico_templates_subtotal_form_subtotal_scope' | i18next }}"
            [aumFormControl]="subtotalTranslatedFormGroup.get('language')"
            [options]="languages"
            (selectionChange)="onLanguageSelectionChange()"
        >
            <aum-form-field-label> {{ 'aumico_admin_form_language' | i18next }} </aum-form-field-label>
        </aum-select>
    </div>
    <aum-select
        placeholder="{{ 'aumico_templates_subtotal_form_subtotal_scope' | i18next }}"
        [aumFormControl]="scopeFormControl"
        [options]="data.scopeOptions"
    >
        <aum-form-field-label>
            {{ 'aumico_templates_subtotal_form_subtotal_scope' | i18next }}
        </aum-form-field-label>
    </aum-select>
    <aum-select
        placeholder="{{ 'aumico_templates_subtotal_form_subtotal_position' | i18next }}"
        [aumFormControl]="positionFormControl"
        [options]="data.positionOptions"
    >
        <aum-form-field-label>
            {{ 'aumico_templates_subtotal_form_subtotal_position' | i18next }}
        </aum-form-field-label>
    </aum-select>
</div>
<div mat-dialog-actions class="action-buttons">
    <aumico-button
        [disabled]="
            subtotalNameControl.invalid ||
            subtotalTranslatedFormGroup.invalid ||
            positionFormControl.invalid ||
            scopeFormControl.invalid
        "
        (click)="save()"
        >{{ 'aumico_templates_save' | i18next }}
    </aumico-button>
    <aumico-button (click)="closeDialog()">{{ 'aumico_templates_cancel' | i18next }}</aumico-button>
</div>
